import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hotRankingArticles } from '@/mocks/articles';

export default function HotRanking() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="w-full lg:w-[38%]">
            <div className="sticky top-24">
              <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[500px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20hot%20topic%20concept%20art%20dramatic%20red%20and%20black%20abstract%20composition%20oriental%20ink%20wash%20painting%20style%20with%20vermilion%20accents%20minimalist%20modern%20aesthetic%20editorial%20design%20atmosphere%20clean%20background&width=700&height=900&seq=hot-ranking-01&orientation=portrait"
                  alt="热门爆料排行"
                  title="爆料网 热门排行榜"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-accent-900/60 to-transparent"></div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[58%] flex flex-col justify-center">
            <span className="text-xs font-medium text-primary-500 tracking-wider mb-4">
              （ {t('home:hot.title')} ）
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-8">
              {t('home:hot.heading')}
              <br />
              <span className="text-foreground-400">{t('home:hot.headingLight')}</span>
            </h2>
            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 pl-4 border-l-2 border-primary-500/30">
              {t('home:hot.description')}
            </blockquote>

            <div className="space-y-3 mb-8">
              {hotRankingArticles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-100 cursor-pointer transition-colors group"
                >
                  <span className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                    idx < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-900'
                  }`}>
                    {idx + 1}
                  </span>
                  <span className="flex-1 text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {article.title}
                  </span>
                  <span className="shrink-0 text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {(article.viewCount / 10000).toFixed(0)}万
                  </span>
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-400 cursor-pointer hover:border-foreground-500 hover:text-foreground-600 transition-colors">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 cursor-pointer hover:bg-accent-600 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-500">— {t('home:hot.author')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}